// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rwNt","input":"styles_input__3P-hT"};